import AppLayout from "@/layouts/app/AppLayout";

import dashboard from "./dashboard"

export default [
  

  {
    path: "/attendee",
    component: AppLayout,
    meta: {
      middleware: ["auth"],
      roles: ["attendee"],
    },
    children: [
        ...dashboard,
    ],
  },
];
